import Vue from 'vue';
import styled from 'vue-styled-components';

import COLORS from '@design/colors.js';

import { Slider as _Slider } from 'ant-design-vue';

export default {
    name: 'Slider',
    props: {
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 0,
        },
        step: {
            type: Number,
            default: 1,
        },
        tooltipVisible: {
            type: Boolean,
            default: false,
        },
        dots: {
            type: Boolean,
            default: false,
        },
        range: {
            type: Boolean,
            default: false,
        },
        marks: {
            type: Object,
            default() {
                return {};
            },
        },
        value: Number | Array,
    },
    render() {
        const props = {
            attrs: {
                ...R.pick(
                    [
                        'range',
                        'tooltipVisible',
                        'dots',
                        'min',
                        'max',
                        'marks',
                        'value',
                        'step',
                    ],
                    this
                ),
                included: true,
            },
            on: {
                change: (value) => this.$emit('change', value),
            },
        };
        return <Slider {...props} />;
    },
};

const Slider = styled(Vue.component('adriel-slider', _Slider))`
    & .ant-slider-track {
        background-color: ${COLORS['blue-60']};
    }
    & .ant-slider-handle {
        border: 1px solid ${COLORS['gray-25']};
    }
    & .ant-slider-rail {
        border-radius: unset;
    }
    & .ant-slider-dot {
        /* visibility: hidden; */
        display: none;
    }
`;
